import { Component, OnInit } from '@angular/core';
import { GithubService } from '../../service/github/github.service';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.css'],
  providers:[GithubService]
})
export class SearchComponent implements OnInit {

  public searchText;
  constructor(private githubservice: GithubService) { }

  ngOnInit() {
  }

  onKeyup(event){
    this.searchText = event.target.value;
  }

  getUsers(){
    this.githubservice.getUser(this.searchText).subscribe(
        res => {
            console.log(res);
        }
    );
  }

}



// WEBPACK FOOTER //
// C:/wamp64/www/duetz.repos/angular4/src/app/_components/search/search.component.ts